<div class="panel panel-default org-panel">
  <div class="panel-heading">
    <b> Please answer the questions below.</b>
    <button style="margin-left: 15px" class="btn btn-info btn-sm" type="button" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i> - </span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>

  <div class="panel-body">
    @for (question of questions; track $index; let odd = $odd) {
<div class="row" [ngClass]="{ 'row-alt': odd }">
      <div class="col-xs-1" style="width: 50px; text-align: center"><b>{{ question.LINE_NO }}</b></div>
      <div class="col-xs-1" style="width: 70px">
        <input type="radio" [name]="'line_' + question.LINE_NO" [value]="'Y'" [(ngModel)]="question.LINE_VALUE" />
        Yes
      </div>
      <div class="col-xs-1" style="width: 70px">
        <input type="radio" [name]="'line_' + question.LINE_NO" [value]="'N'" [(ngModel)]="question.LINE_VALUE" />
        No
      </div>
      <div class="col-md-8">{{ question.DESCRIPTION }}</div>
    </div>
}
  </div>
</div>
